import { render, staticRenderFns } from "./deleteIngredientQuantityModalContent.vue?vue&type=template&id=22b232e6&scoped=true"
import script from "./deleteIngredientQuantityModalContent.vue?vue&type=script&lang=js"
export * from "./deleteIngredientQuantityModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b232e6",
  null
  
)

export default component.exports